import { Box, Button, Dialog, H1, H2, Separator, Text } from '@betterment/samba-react';

import VestingAccordion from './VestingAccordion';

import StudentLoanMatchGuidanceBox from '../../../../FourOhOneK/components/StudentLoanMatchGuidanceBox';

export type MatchDetailsDialogProps = {
  ctaDescription?: string | null;
  discretionaryWithTiersDescription?: string | null;
  hasVesting: boolean;
  longDescription: string;
  shortDescription: string;
};

export const MatchDetailsDialog: React.FC<MatchDetailsDialogProps> = ({
  ctaDescription,
  discretionaryWithTiersDescription,
  hasVesting,
  longDescription,
  shortDescription,
}) => {
  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <Button variant="textPrimary">Match details</Button>
      </Dialog.Trigger>
      <Dialog.Content size="large" css={{ padding: 'space.300', display: 'grid', gap: 'space.200' }}>
        <Dialog.Title asChild={true}>
          <Box css={{ display: 'grid', gap: 'space.100' }}>
            <H2 variant="title300">Your match details</H2>
            {ctaDescription && <Text>{ctaDescription}</Text>}
          </Box>
        </Dialog.Title>
        <Separator />
        <Dialog.Description asChild={true}>
          <Box css={{ display: 'grid', gap: 'space.200', mt: 'space.100' }}>
            <H1 variant="title100">{shortDescription}</H1>
            {discretionaryWithTiersDescription && <Text>{discretionaryWithTiersDescription}</Text>}
            <Text>{longDescription}</Text>
            {hasVesting && <VestingAccordion />}
            <StudentLoanMatchGuidanceBox location="goal_overview_employer_match" />
          </Box>
        </Dialog.Description>
        <Dialog.Close asChild={true}>
          <Box css={{ display: 'flex', mt: 'space.100' }}>
            <Button variant="solidSecondary">Close</Button>
          </Box>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog>
  );
};
